module.exports = __webpack_public_path__ + "static/media/icon-event__i-guerra-mundial.da9b28ee.svg";